export default "__VITE_ASSET__CPlhuK5B__"